// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#main-layout {
  display: grid;
  grid-template-columns: minmax(0, 220px) minmax(0, 1fr);
}
#main-layout cp-navigation {
  min-width: 0;
  overflow: hidden;
}
#main-layout > div {
  min-width: 0;
}
#main-layout.menu-collapsed {
  grid-template-columns: 0 minmax(0, 1fr);
}
#main-layout.menu-collapsed cp-navigation {
  pointer-events: none;
  visibility: hidden;
}

@media only screen and (max-width: var(--media-tablet)) and (min-width: 0px) {
  #main-layout {
    grid-template-columns: minmax(0, 300px) minmax(0, 1fr);
    margin-left: 0;
    width: 100%;
    left: 0px !important;
  }
  #main-layout.menu-collapsed {
    grid-template-columns: 0 minmax(0, 1fr);
  }
}
@media only screen and (max-width: 679px) and (min-width: 0) {
  #main-layout {
    margin-top: 40px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/core/layout/app-layouts/main-layout.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sDAAA;AACF;AACE;EACE,YAAA;EACA,gBAAA;AACJ;AAEE;EACE,YAAA;AAAJ;AAGE;EACE,uCAAA;AADJ;AAGI;EACE,oBAAA;EACA,kBAAA;AADN;;AAMA;EACE;IACE,sDAAA;IACA,cAAA;IACA,WAAA;IACA,oBAAA;EAHF;EAKE;IACE,uCAAA;EAHJ;AACF;AAOA;EACE;IACE,gBAAA;EALF;AACF","sourcesContent":["#main-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 220px) minmax(0, 1fr);\n\n  cp-navigation {\n    min-width: 0;\n    overflow: hidden;\n  }\n\n  > div {\n    min-width: 0;\n  }\n\n  &.menu-collapsed {\n    grid-template-columns: 0 minmax(0, 1fr);\n\n    cp-navigation {\n      pointer-events: none;\n      visibility: hidden;\n    }\n  }\n}\n\n@media only screen and (max-width: var(--media-tablet)) and (min-width: 0px) {\n  #main-layout {\n    grid-template-columns: minmax(0, 300px) minmax(0, 1fr);\n    margin-left: 0;\n    width: 100%;\n    left: 0px !important;\n\n    &.menu-collapsed {\n      grid-template-columns: 0 minmax(0, 1fr);\n    }\n  }\n}\n\n@media only screen and (max-width: 679px) and (min-width: 0) {\n  #main-layout {\n    margin-top: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
